var _defs, _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _g2, _g3, _path15, _line, _g4, _path16, _g5, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g6, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImages2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_109_1",
    "data-name": "Component 109 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 398.762,
    height: 340.979,
    viewBox: "0 0 398.762 340.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.316,
    y1: 0.5,
    x2: 1.316,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#479387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2fd4e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9453e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#a64339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#9d3f2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#8f3913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -57.313,
    y1: 0.5,
    x2: -56.313,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -82.836,
    y1: 0.5,
    x2: -81.836,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -27.612,
    y1: -8.224,
    x2: -28.476,
    y2: -9.416,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -202.657,
    y1: 0.5,
    x2: -201.657,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -274.1,
    y1: 0.5,
    x2: -273.1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -198.247,
    y1: 0.5,
    x2: -197.247,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -276.715,
    y1: 0.5,
    x2: -275.715,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.004,
    y1: 0.473,
    x2: 0.998,
    y2: 0.555,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#8f3913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#9d3f2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#a64339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a9453e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7648",
    "data-name": "Path 7648",
    d: "M3334.388,2468.046v320.37l39.2-5.58,122.091-17.38,167.71-23.87.43-122.86a77.462,77.462,0,0,1-80.07-124Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "#eeeafe"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_796",
    "data-name": "Ellipse 796",
    cx: 64.473,
    cy: 64.473,
    r: 64.473,
    transform: "translate(263.342 12.683)",
    fill: "#eeeafe"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_797",
    "data-name": "Ellipse 797",
    cx: 64.473,
    cy: 64.473,
    r: 64.473,
    transform: "translate(268.34 11.018)",
    fill: "none",
    stroke: "#c9c6e0",
    strokeMiterlimit: 10,
    strokeWidth: 2.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7649",
    "data-name": "Path 7649",
    d: "M3492.148,2765.3c-.007.022-48.739,8.835-53.647,7.864-1.757-.341-6.6-11.016-7.011-15.33a134.66,134.66,0,0,1,.149-29.083c.066-.5.141-1.009.222-1.506.148-.963.319-1.912.512-2.839.556-2.706,1.253-5.271,1.912-7.7,5.583-20.506-29.446-55.48-18.222-66.244a13.248,13.248,0,0,1,2.9-2.165c3.3-1.765,10.06-1.308,14.441,1.064,3.855,2.083,10.89,6.539,15.379,12.569,22.425,30.124,23.6,36.367,27.484,44C3483.439,2720.032,3491.442,2755.813,3492.148,2765.3Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7650",
    "data-name": "Path 7650",
    d: "M3345.127,2603.834c8.291,23.959,34.442,26.855,39.676,19.377,3.951-5.644,9.764-5.206,14.4-10.307,2.637-2.905,5.119-5.989,8.182-8.442,4.571-3.662,10.184-5.724,15.278-8.612,13.412-7.6,27.182-12.511,28.558-36.952.167-2.96-1.929-5.6-2.88-8.41a18.63,18.63,0,0,0-3.9-6.07,72.513,72.513,0,0,0-24.5-18.219,52.137,52.137,0,0,0-13.69-4.253c-17.155-2.593-34.864,6.546-44.906,20.7a62.539,62.539,0,0,0-10.262,25.141,76.776,76.776,0,0,0-1.193,13.852c.013,4.31,1.242,8.924.783,13.149C3350.41,2597.1,3349.906,2602.883,3345.127,2603.834Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7651",
    "data-name": "Path 7651",
    d: "M3413.347,2621.436l4.166,34.073s-34.846-.88-40.659-.014c1.518-15.607,2.644-30.685,3.509-38.891C3385.625,2621.413,3409.682,2622.04,3413.347,2621.436Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "#fa997b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7652",
    "data-name": "Path 7652",
    d: "M3379.686,2623.692a125.249,125.249,0,0,0,35.9,16.06l-1.409-11.521S3394.166,2628.868,3379.686,2623.692Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "#ef5d23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7653",
    "data-name": "Path 7653",
    d: "M3363.379,2752.655c.1,1.046.16,2.094.2,3.158l96.389-10.037c-4.844-16.653-5.307-35.9-16.219-59.124-5.394-11.48-14.2-34.054-24.328-36.616-6.186-1.566-7.746,5.363-17.754,4.254-10.271-1.137-24.817-18.234-32.1-12.245C3349.514,2658.549,3358.606,2700.6,3363.379,2752.655Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "url(#linear-gradient-3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7654",
    "data-name": "Path 7654",
    d: "M3314.525,2767.7a65.033,65.033,0,0,0,6.509,21.478c.009.027,28.293,15.283,34.166,14.121,2.1-.408,4.351,2,5.921-3.9.55-2.049,1.074-4.3,1.579-6.725.373-1.81.737-3.717,1.074-5.7.781-4.569,1.446-9.547,1.934-14.71a161.134,161.134,0,0,0-.177-34.8c-.08-.6-.169-1.207-.267-1.8-.177-1.154-.381-2.289-.612-3.4-.665-3.239-1.5-6.308-2.289-9.218-6.68-24.54,31.141-66.6,17.709-79.485a15.9,15.9,0,0,0-3.469-2.591c-3.948-2.111-7.941-1.357-13.184,1.482-4.613,2.493-9.581,5.348-17.153,13.066-18.945,19.309-24.765,33.6-29.53,47.949C3312.663,2715.728,3312.573,2738.616,3314.525,2767.7Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "url(#linear-gradient-4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7655",
    "data-name": "Path 7655",
    d: "M3351.3,2696.234c7.2-6.352,9.706,6.645,4.383,14.16s8.144,28.958,8.144,28.958l1.437-3.7c-.177-1.154-.381-2.289-.612-3.4-.665-3.239-1.5-6.308-2.289-9.218-6.68-24.54,31.141-66.6,17.709-79.485a15.9,15.9,0,0,0-3.469-2.591c-3.948-2.111-7.941-1.357-13.184,1.482,0,0,17.425,2.5,11.889,13.468s-16.343,17.371-25.108,25.205S3344.1,2702.578,3351.3,2696.234Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "#231f20",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7656",
    "data-name": "Path 7656",
    d: "M3317.323,2779.043c.079,8.914,7.081,16.846,16.728,22.2.313.174.628.341.943.508.368.205.747.4,1.133.595l.013,0c7.71,3.907,15.793,6.308,20.735,6.625,16.488,1.067,61.821-15.117,79.562-19.958s35.017-13.638,41.357-24.265c3.251-5.453,5.527-8.687,7.853-10.919q.271-.257.535-.493l.007,0a16.1,16.1,0,0,1,1.719-1.355,28.5,28.5,0,0,1,5.418-2.82,32.721,32.721,0,0,0,5.825-2.908c2.3-1.588,3.421-3.514,2.036-6.246a33.868,33.868,0,0,0-2.236-2.979c-.386-.407-.773-.813-1.146-1.216-2.788-3-7.927-4.495-7.927-4.495a12.472,12.472,0,0,0-4.926-1.132c-.463-.009-.932,0-1.416.038a23.506,23.506,0,0,0-8.534,2.6l-.02-.006-.009.005c-.657-.053-1.266-.127-1.833-.218-4.606-.767-6.873-2.9-11.771-5.962-5.51-3.456-16.35-9.415-35.564,3.5-19.195,12.894-27.278,17.5-34.143,16.833-2.913-.273-13.831.843-26.466,3.713-1.121.251-2.262.518-3.406.8-15.559,3.849-32.819,10.308-40.693,20.031-.11.127-.416.55-.807,1.136l-.038.054C3319.127,2774.4,3317.308,2777.427,3317.323,2779.043Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "url(#linear-gradient-5)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7657",
    "data-name": "Path 7657",
    d: "M3317.323,2779.043c.079,8.914,7.081,16.846,16.728,22.2.313.174.628.341.943.508.368.205.747.4,1.133.595l.013,0c7.71,3.907,15.793,6.308,20.735,6.625,16.488,1.067,61.821-15.117,79.562-19.958s35.017-13.638,41.357-24.265c3.251-5.453,6.062-9.179,8.388-11.412-1.986-4.022-7.274-3.21-7.274-3.21s-18.389,9.523-28.855,20.143c-14.549,14.77-53.4,18.266-68.755,11.087-9.192-4.294-20.926-8-28.525-7.123-4.229.484-6.472,2.749-4.862,7.616.4,1.232,3.828,9.243.817,12.394-4.659,4.869-13.032.618-18.983-4.183-7.025-5.66-9.473-10.126-9.365-17.517l-.09.11-.038.054C3319.127,2774.4,3317.308,2777.427,3317.323,2779.043Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "#231f20",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7658",
    "data-name": "Path 7658",
    d: "M3486.431,2724.927s6.929-7.144,9.208-13.783,5.152-12.089,7.927-13.972,8.026-7.828,7.927-13.872,5.153-4.657,6.342,0,1.288,10.3-4.063,17.341,1.189,8.125,7.035,6.738,13.278-3.667,13.477,4.657.5,19.917-1.685,25.367-11.891,10.4-21.6,9.314-13.972-.793-13.972-.793Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "#fa997b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7659",
    "data-name": "Path 7659",
    d: "M3486.022,2753.288h.006a18.2,18.2,0,0,1,1.734-1.348c1.578-1.085,3.855-1.393,6.011-2.276,5.533-2.263,11.093-2.405,8.735-7-.108-.219-2.241-4.059-2.35-4.191-.36-.477-10.414-14.083-10.8-14.492-2.832-2.974-6.981,1.991-14.725,8.731-.673-.052-.288,2.205-.274,3.318C3474.656,2739.418,3474.36,2753.225,3486.022,2753.288Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "#40847d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7660",
    "data-name": "Path 7660",
    d: "M3455.742,2723.747s-12.575-7.011-31.447,7.064c-18.488,13.788-25,16.886-33.619,16.663a81.267,81.267,0,0,0-17.5,1.806s12.577-.664,16.911.255,19.818-2.878,36.671-16.765C3434.184,2726.806,3452.011,2721.939,3455.742,2723.747Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "#40847d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7661",
    "data-name": "Path 7661",
    d: "M3349.155,2569.095c-.185-14.179,3.684-28.46,11.622-39.385,7.637-10.51,19.364-16.722,33.281-17.108s24.7,4,33.319,12.4c9.5,9.257,14.161,23.016,13.044,36.232-.49,5.8-2.012,11.48-2.3,17.29-.528,10.511,2.94,21.426-.526,31.362-2.99,8.57-10.881,14.823-19.551,17.509s-18.037,2.2-26.948.465c-12.624-2.451-23.123-11.422-30.551-21.747C3353.129,2595.816,3349.33,2582.5,3349.155,2569.095Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "#fa997b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4804",
    "data-name": "Group 4804",
    transform: "translate(-3313.287 -2468.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4803",
    "data-name": "Group 4803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7662",
    "data-name": "Path 7662",
    d: "M3409.973,2607.777a21.728,21.728,0,0,1-16.365-5.108,9.557,9.557,0,0,0,6.621,9.084C3407.089,2614.075,3409.973,2607.777,3409.973,2607.777Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7663",
    "data-name": "Path 7663",
    d: "M3403.119,2615.34a9.473,9.473,0,0,1-5.631-1.651",
    fill: "none",
    stroke: "#d26665",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4805",
    "data-name": "Group 4805",
    transform: "translate(-3313.287 -2468.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7664",
    "data-name": "Path 7664",
    d: "M3389.608,2558.784c5.934-2.146,10.124,1.2,10.621,4.487a21.831,21.831,0,0,0-9.29-.37,34.77,34.77,0,0,0-10.152,3.307A17.862,17.862,0,0,1,3389.608,2558.784Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7665",
    "data-name": "Path 7665",
    d: "M3425.066,2558.784c-5.934-2.146-10.124,1.2-10.621,4.487a21.83,21.83,0,0,1,9.29-.37,34.77,34.77,0,0,1,10.152,3.307A17.862,17.862,0,0,0,3425.066,2558.784Z",
    fill: "#1a1a1a"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4806",
    "data-name": "Group 4806",
    transform: "translate(-3313.287 -2468.046)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_798",
    "data-name": "Ellipse 798",
    cx: 19.853,
    cy: 19.853,
    r: 19.853,
    transform: "translate(3414.19 2555.496)",
    fill: "rgba(255,255,255,0.2)",
    stroke: "#d0d2d3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7666",
    "data-name": "Path 7666",
    d: "M3419.843,2562.5l21.236,30.87a14.65,14.65,0,0,0,2.7-1.291,22.016,22.016,0,0,0,5-4.209l-21.269-30.95A19.767,19.767,0,0,0,3419.843,2562.5Z",
    opacity: 0.3,
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7667",
    "data-name": "Path 7667",
    d: "M3415.556,2570.4l15.615,24.059a17.1,17.1,0,0,0,3.706.191c.5,0,2.006-.2,2.016-.207l-19.287-29.232a19.31,19.31,0,0,0-.94,1.94A15.971,15.971,0,0,0,3415.556,2570.4Z",
    opacity: 0.3,
    fill: "url(#linear-gradient-7)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7668",
    "data-name": "Path 7668",
    d: "M3465.158,2544.065c-7,8.07-11.87,16.56-22.63,18.24-25.02,3.9-55.54-18.06-59.79-26.89-3.34,31.36-21.75,29.64-27.49,40.15-2.31,4.23-6.97,7.01-8.38,11.57-5.45-10.44-10.27-21.36-12.05-32.92s-2.16-25.65,7.63-36.2,23.63-8,23.63-8,18.33-15.1,35.71-16.35c19.1-1.38,28.13.63,40.45,17.33,6.26,8.49,15.08,33.98,22.9,33.07Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "url(#linear-gradient-2)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x1: 18.959,
    transform: "translate(32.331 102.326)",
    fill: "rgba(255,255,255,0.2)",
    stroke: "#d0d2d3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4807",
    "data-name": "Group 4807",
    transform: "translate(-3313.287 -2468.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7669",
    "data-name": "Path 7669",
    d: "M3341.2,2585.379c3.564,9.587,12.3,15.316,16.685,13.185,3.4-1.654,3.938-8.038,1.957-15.7s-7.7-17.4-13.479-15.946S3337.631,2575.792,3341.2,2585.379Z",
    fill: "#fa997b"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7670",
    "data-name": "Path 7670",
    d: "M3354.4,2581.06c1.553,2.5,1.646,5.265.2,6.165s-3.884-.4-5.447-2.909c-1.545-2.506-1.634-5.269-.191-6.165S3352.847,2578.549,3354.4,2581.06Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "#ef5d23"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4812",
    "data-name": "Group 4812",
    transform: "translate(-3313.287 -2468.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4809",
    "data-name": "Group 4809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7671",
    "data-name": "Path 7671",
    d: "M3417.274,2578.475s-.908-6.749,3.4-9.108,9.672.76,8.158,4.95Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7672",
    "data-name": "Path 7672",
    d: "M3417.5,2579.3c.83,2.491,9.231,2.572,11.364-2.282s-2.2-9.051-6.224-7.824A7.79,7.79,0,0,0,3417.5,2579.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4808",
    "data-name": "Group 4808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7673",
    "data-name": "Path 7673",
    d: "M3421.783,2575.517a5.474,5.474,0,0,1-.1-.608,3.632,3.632,0,0,1,.241-2.416,3.984,3.984,0,0,1,.577-.989c1.216-1.5,3.021-1.356,4.532-.464a3.408,3.408,0,0,1,1.576,2.516,3.925,3.925,0,0,1,.22,1.21,3.286,3.286,0,0,1-2.957,3.475A3.825,3.825,0,0,1,3421.783,2575.517Z",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4811",
    "data-name": "Group 4811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7674",
    "data-name": "Path 7674",
    d: "M3396.5,2578.475s.908-6.749-3.4-9.108-9.733.76-8.218,4.95Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7675",
    "data-name": "Path 7675",
    d: "M3396.267,2579.3c-.829,2.491-9.231,2.572-11.363-2.282s2.2-9.051,6.223-7.824A7.789,7.789,0,0,1,3396.267,2579.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4810",
    "data-name": "Group 4810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7676",
    "data-name": "Path 7676",
    d: "M3388.98,2576.664a5.644,5.644,0,0,1-.186-.587,3.625,3.625,0,0,1-.114-2.425,3.915,3.915,0,0,1,.426-1.063c.984-1.658,2.79-1.783,4.416-1.122a3.414,3.414,0,0,1,1.926,2.259,3.915,3.915,0,0,1,.4,1.165,3.287,3.287,0,0,1-2.419,3.87A3.824,3.824,0,0,1,3388.98,2576.664Z",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7677",
    "data-name": "Path 7677",
    d: "M3426.6,2572.865a.73.73,0,0,0,1.461,0,.966.966,0,0,0-.792-.917C3426.866,2571.948,3426.6,2572.461,3426.6,2572.865Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7678",
    "data-name": "Path 7678",
    d: "M3393.462,2573.688a.731.731,0,1,0,1.461,0,.966.966,0,0,0-.793-.916C3393.727,2572.772,3393.462,2573.285,3393.462,2573.688Z",
    fill: "#fff"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7679",
    "data-name": "Path 7679",
    d: "M3409.484,2582.035s-.593,4.507.314,6.11,3.674,2.9,2.557,6.23c-1.315,3.915-5.025,2.238-5.025,2.238",
    transform: "translate(-3313.287 -2468.046)",
    fill: "none",
    stroke: "#d26665",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7680",
    "data-name": "Path 7680",
    d: "M3403.753,2575.99s5.153-5.029,10.182,0",
    transform: "translate(-3313.287 -2468.046)",
    fill: "none",
    stroke: "#d0d2d3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7681",
    "data-name": "Path 7681",
    d: "M3428.332,2657.174s8.132,14.537,16.865,32.931C3445.854,2674.811,3434.73,2665.5,3428.332,2657.174Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "#40847d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7682",
    "data-name": "Path 7682",
    d: "M3364.051,2575.346a19.813,19.813,0,0,0,19.85,19.86c.65,0,1.3-.03,1.94-.09a.06.06,0,0,0,.04-.01,19.561,19.561,0,0,0,4.41-.95,20.094,20.094,0,0,0,2.73-1.18,19.849,19.849,0,0,0-9.12-37.48,19.529,19.529,0,0,0-7.51,1.48,19.766,19.766,0,0,0-7.67,5.58,20.168,20.168,0,0,0-2.2,3.2,19.567,19.567,0,0,0-2.05,5.53,18.57,18.57,0,0,0-.41,3.75C3364.051,2575.136,3364.051,2575.246,3364.051,2575.346Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "rgba(255,255,255,0.2)",
    stroke: "#d0d2d3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7683",
    "data-name": "Path 7683",
    d: "M3368.935,2563.015l21.08,30.68a20.055,20.055,0,0,0,2.73-1.18,19.746,19.746,0,0,0,5.26-3.94l-21.4-31.14A19.767,19.767,0,0,0,3368.935,2563.015Z",
    transform: "translate(-3313.287 -2468.046)",
    opacity: 0.3,
    fill: "url(#linear-gradient-9)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7684",
    "data-name": "Path 7684",
    d: "M3364.965,2571.49l14.84,22.776a20.491,20.491,0,0,0,3.948.453c.65,0,1.97-.09,1.98-.1l-18.718-28.658a19.564,19.564,0,0,0-2.05,5.529Z",
    transform: "translate(-3313.287 -2468.046)",
    opacity: 0.3,
    fill: "url(#linear-gradient-10)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7685",
    "data-name": "Path 7685",
    d: "M3342.921,2517.523s7.73-12.4,17.793-9.691c5.71,1.538,5.552,2.479,5.552,2.479s-1.231-4.283,7.735-6.736c8.086-2.212,1.231-6.792,15.841-8.791,5.6-2.268,3.893.348,9.9-.908",
    transform: "translate(-3313.287 -2468.046)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.097
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4816",
    "data-name": "Group 4816",
    transform: "translate(-3313.287 -2468.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4814",
    "data-name": "Group 4814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4813",
    "data-name": "Group 4813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7686",
    "data-name": "Path 7686",
    d: "M3669.571,2533.061a24.311,24.311,0,0,1-7.289,17.383,28.632,28.632,0,0,0-7.155,11.872c-.6,1.764-2.424,7.526-2.424,7.526h-15.645l-.844-3.128-1.12-4.141a27.685,27.685,0,0,0-7.161-12.3,24.373,24.373,0,0,1,11.522-40.9h0a24.378,24.378,0,0,1,30.112,23.691Z",
    fill: "none",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7687",
    "data-name": "Path 7687",
    d: "M3636.208,2566.675l.66,7.98a4.14,4.14,0,0,0,4.22,3.7h7.79a4.143,4.143,0,0,0,4.23-3.7l.75-8.09Zm16.09,8.31c-4.93-.15-9.87.15-14.81-.01a.335.335,0,0,1-.02-.67c4.93-.22,9.87.03,14.8-.18C3652.828,2574.1,3652.858,2575,3652.3,2574.985Zm0-2.14c-4.93-.16-9.87.15-14.81-.01a.34.34,0,0,1-.02-.68c4.93-.21,9.87.04,14.8-.17C3652.828,2571.955,3652.858,2572.865,3652.3,2572.845Z",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4815",
    "data-name": "Group 4815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7688",
    "data-name": "Path 7688",
    d: "M3655.713,2538.093a6.281,6.281,0,0,1-1.836-2.167,7.686,7.686,0,0,0,1.436-3.924,24.4,24.4,0,0,0,.14-2.509,2.16,2.16,0,0,0-.779-2c-.61-.448-1.426-.043-1.9.392a4.543,4.543,0,0,0-1.011,2.011,9.021,9.021,0,0,0-.149,4.28,8.527,8.527,0,0,0,.407,1.443,3.754,3.754,0,0,1-1.171.624,2.446,2.446,0,0,1-2.959-1.477c-.1-.187-.2-.384-.288-.59.1-.281.205-.561.3-.839a17.55,17.55,0,0,0,.817-4.179c.094-1.174.127-2.577-1-3.272a.744.744,0,0,0-1,.262c-1.65,2.29-1.557,5.326-.661,7.924a17.231,17.231,0,0,1-1,2.007c-.414.712-1.2,1.812-2.162,1.672-.892-.13-1.606-1.25-2.049-1.942a7.927,7.927,0,0,1-.782-1.613q.171-.449.316-.905a16.6,16.6,0,0,0,.693-3.7c.083-1.046.117-2.515-1.027-3.016a.743.743,0,0,0-1,.263,10.476,10.476,0,0,0-.563,7.053c.022.081.047.16.071.24a15.518,15.518,0,0,1-3.029,4.79c-.575.624.335,1.545.934.934a16.27,16.27,0,0,0,2.833-3.927,10.265,10.265,0,0,0,.74,1.189,4.182,4.182,0,0,0,3.027,2.075c1.255.068,2.274-.987,2.954-1.905a9.836,9.836,0,0,0,.866-1.419,3.856,3.856,0,0,0,2.709,1.925,4.461,4.461,0,0,0,3.1-.8,9.243,9.243,0,0,0,2.026,2.4A.822.822,0,1,0,3655.713,2538.093Zm-8.4-10.167a9.25,9.25,0,0,1-.116,1.659,14.006,14.006,0,0,1-.322,1.92A6.688,6.688,0,0,1,3647.317,2527.926Zm5.7,3.674a6.946,6.946,0,0,1,.408-1.775,3.585,3.585,0,0,1,.355-.735,1.51,1.51,0,0,1,.114-.142,1.167,1.167,0,0,1,.029.176,12.626,12.626,0,0,1-.5,4.486,4.418,4.418,0,0,1-.2.509A8.312,8.312,0,0,1,3653.012,2531.6Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7689",
    "data-name": "Path 7689",
    d: "M3657.1,2534.507c-2.592,7.912-5.32,15.783-8.251,23.576-.351.933.57,1.031.919.1,2.922-7.8,5.872-15.9,8.583-23.176C3658.65,2534.2,3657.371,2533.679,3657.1,2534.507Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7690",
    "data-name": "Path 7690",
    d: "M3633.524,2534.007c2.068,8.065,4.712,15.941,6.43,24.087.206.975,1.014.912.807-.062-1.733-8.15-3.68-16.249-5.915-24.277C3634.616,2532.927,3633.307,2533.163,3633.524,2534.007Z",
    fill: "#404041"
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7691",
    "data-name": "Path 7691",
    d: "M3465.158,2544.065c-7,8.07-11.87,16.56-22.63,18.24-25.02,3.9-55.54-18.06-59.79-26.89,0,0,44.38,28.1,66.04,18.4,10.46-4.56,13.66-8.42,16.36-9.75Z",
    transform: "translate(-3313.287 -2468.046)",
    fill: "url(#linear-gradient-11)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages2);
export default __webpack_public_path__ + "static/media/images2.d3c162895aeabbdd2b2ff728542c59e1.svg";
export { ForwardRef as ReactComponent };